import {
  Component,
  computed,
  inject,
  OnDestroy,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { NotificationService } from "../../../services/notification.service";
import {
  INotificationItem,
  NotificationCategory,
  NotificationService1,
} from "../../../services/notification1.service";
import { AppService } from "../../../services/app.service";
import { CommonModule } from "@angular/common";
import { Router } from "@angular/router";
import {
  _AbcButtonComponent,
  AbcPopupComponent,
} from "@barthauer/abc/ui-components";
import { NotificationMessage, ToastType } from "@barthauer/custom/xmt-models";
import { DxLoadIndicatorModule, DxSwitchModule } from "devextreme-angular";
import { DxoPositionModule } from "devextreme-angular/ui/nested";
import { formatMessage } from "devextreme/localization";
import { FlexLayoutModule } from "ngx-flexible-layout";
import { Subscription, finalize, switchMap, of, tap } from "rxjs";
import { DataService } from "../../../services/data.service";
import { ConfirmationPopupComponent } from "../../confirmation-popup/confirmation-popup.component";
import { DatePipe } from "../../pipes/date.pipe";

@Component({
  selector: "notification-popup",
  imports: [
    _AbcButtonComponent,
    AbcPopupComponent,
    CommonModule,
    DxLoadIndicatorModule,
    DxSwitchModule,
    DxoPositionModule,
    FlexLayoutModule,
    ConfirmationPopupComponent,
    DatePipe,
  ],
  templateUrl: "./notification-popup.component.html",
  styleUrls: ["./notification-popup.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class NotificationPopupComponent implements OnDestroy {
  @ViewChild("notificationPopup", { static: false })
  notificationPopup: AbcPopupComponent;
  @ViewChild("markAllReadConfirmPopup", { static: false })
  markAllReadConfirmPopup: ConfirmationPopupComponent;

  private notificationService1 = inject(NotificationService1);
  private notificationService = inject(NotificationService);
  public dataService = inject(DataService);
private appService =inject(AppService);
  private router = inject(Router);
  private readonly subscriptions: Subscription[] = [];

  protected formatMessage: (key: string, ...values: Array<string>) => string =
    formatMessage;
  protected showLoader: boolean = false;
  protected readonly unreadNotifications = computed(() => {
    return this.notificationService1.unreadNotifications();
  });

  constructor() { }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  public showPopup(): void {
    this.notificationPopup.instance.show();
  }

  protected onPopupShown(e): void {
    e.component
      .content()
      .parentElement.parentElement.classList.add("notification-popup");
  }

  protected async onMarkAllAsRead(): Promise<void> {
    if (await this.markAllReadConfirmPopup.open()) {
      this.showLoader = true;
      this.subscriptions.push(
        this.notificationService1
          .markAllNotificationsAsRead()
          .pipe(
            finalize(() => {
              this.showLoader = false;
            })
          )
          .subscribe({
            next: () => {
              this.notificationService.callNotification({
                message: this.dataService.res(
                  NotificationMessage.UpdatedSuccessfully
                ),
                type: ToastType.SUCCESS,
              });
            },
            error: () => {
              this.notificationService.callNotification({
                message: this.dataService.res(NotificationMessage.Error),
                type: ToastType.ERROR,
              });
            },
          })
      );
    }
  }

  protected redirectToDetails(notificationItem: INotificationItem): void {
    this.showLoader = true;
 
 
  if(notificationItem.ProjectId!== sessionStorage.getItem('projectId')){
    sessionStorage.setItem('projectId',notificationItem.ProjectId)
    sessionStorage.setItem('projectName',notificationItem.ProjectName)
  
  }
   this.appService.projectName.set(notificationItem.ProjectName)
 

    this.notificationService1
      .markNotificationAsRead(notificationItem.Id)
      .pipe(
        tap(() => {
          this.closePopUp();

          switch (notificationItem.Category) {
            case NotificationCategory.APPROVAL_STEP:
            case NotificationCategory.MEASURE_TASK:
            case NotificationCategory.APPROVAL_REQUEST:
            case NotificationCategory.MEASURE_PROGRESS:
            case NotificationCategory.MEASURE:
              this.router.navigate([
                "measureDetail",
                "measures",
                notificationItem.MeasureId,
              ]);
              break;

            default:
              console.warn(
                "Unhandled notification category:",
                notificationItem.Category
              );
          }
        }),
        finalize(() => {
          this.showLoader = false;
        })
      )
      .subscribe();
  }

  protected get NotificationCategory(): typeof NotificationCategory {
    return NotificationCategory;
  }

  protected formatDate(date: string): string {
    return this.dataService.formatDate(date, true);
  }

  protected onGoToNotifications(): void {
    this.router.navigate(["notification"]);
    this.closePopUp();
  }

  private closePopUp(): void {
    this.notificationPopup.instance.hide();
  }

  protected get isAdmin(): boolean {
    return true;
  }
}
